import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { memedApi } from '@/api/memed';

export function useMemedSync(prescriptionId: string) {
  const queryClient = useQueryClient();

  const { data: status, refetch } = useQuery({
    queryKey: ['memed', 'prescription', prescriptionId],
    queryFn: () => memedApi.getStatus(prescriptionId),
    enabled: !!prescriptionId,
  });

  const sendMutation = useMutation({
    mutationFn: () => memedApi.sendToMemed(prescriptionId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['memed', 'prescription', prescriptionId],
      });
    },
  });

  const retryMutation = useMutation({
    mutationFn: () => memedApi.sendToMemed(prescriptionId),
    onSuccess: () => refetch(),
  });

  return { status, sendMutation, retryMutation, refetch };
}
